import { Link } from "react-router-dom";

const subTitle = "Popular Category";
const title = "We've Got You Covered";
const btnText = "Browse All Categories";


const categoryList = [
    {
        imgUrl: 'assets/images/category/icon/01.jpg',
        imgAlt: 'Lego Services',
        title: 'Lego Services',
    },
    {
        imgUrl: 'assets/images/category/icon/02.jpg',
        imgAlt: 'Coding',
        title: 'Coding',
    },
    {
        imgUrl: 'assets/images/category/icon/03.jpg',
        imgAlt: 'Arduino Robotics',
        title: 'Arduino Robotics',
        count: '',
    },
    {
        imgUrl: 'assets/images/category/icon/04.jpg',
        imgAlt: 'Engineering',
        title: 'Engineering',
    },
    {
        imgUrl: 'assets/images/category/icon/05.jpg',
        imgAlt: '3D Modeling',
        title: '3D Modeling',
    },
    {
        imgUrl: 'assets/images/category/icon/06.jpg',
        imgAlt: 'Extracurricular',
        title: 'Extracurricular',
    },
]


const Category = () => {
    return (
        <div className="category-section padding-tb">
            <div className="container">
                <div className="section-header text-center">
                    <span className="subtitle" style={{ color: "var(--theme-primary-color" }}>{subTitle}</span>
                    <h2 className="title">{title}</h2>
                </div>
                <div className="section-wrapper">
                    <div className="row g-2 justify-content-center row-cols-xl-6 row-cols-md-3 row-cols-sm-2 row-cols-1">
                        {categoryList.map((val, i) => (
                            <div className="col" key={i}>
                                <div className="category-item text-center" style={{ height: '100%' }}>
                                    <div className="category-inner" style={{ height: '100%', transition: 'all 0.3s ease', cursor: 'pointer' }} 
                                         onMouseOver={(e) => e.currentTarget.querySelector('h6').style.color = 'var(--theme-primary-color-hover)'}
                                         onMouseOut={(e) => e.currentTarget.querySelector('h6').style.color = ''}>
                                        <div className="category-thumb">
                                            <img src={`${val.imgUrl}`} alt={val.imgAlt} />
                                        </div>
                                        <div className="category-content">
                                            <Link to="/course"><h6>{val.title}</h6></Link>
                                            <span>{val.count}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        ))}
                    </div>
                    <div className="text-center mt-5">
                        <Link to="/course" className="lab-btn" style={{ backgroundColor: "var(--theme-primary-color)"}}><span>{btnText}</span></Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Category;